import { IDeleteAssistenciaRegistroAtendimentoUseCase } from "../../../presentation/useCases/delete/delete_assistencia_registro_atendimento_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteAssistenciaRegistroAtendimentoUseCase
 */

export class DeleteAssistenciaRegistroAtendimentoUseCase implements IDeleteAssistenciaRegistroAtendimentoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async deleteAssistenciaRegistroAtendimento(
    idAssistenciaTecnica: number,
    idAssistenciaAtendimento: number,
  ): Promise<void> {
    await this.repository.deleteAssistenciaRegistroAtendimento(
      idAssistenciaTecnica,
      idAssistenciaAtendimento,
    );
  }
}
